import { create } from "zustand";

type AuthState = {
  accessToken: string;
  setAuth: (accessToken?: string) => void;
};

export const useAuth = create<AuthState>()((set) => ({
  accessToken: "",
  setAuth: (accessToken) =>
    set(() => ({
      accessToken,
    })),
}));
